import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useAuth } from "shared/context/auth";

export default function SetSentryContext() {
  const auth = useAuth();
  const userId = auth?.userDetail?.id || "";
  useEffect(() => {
    Sentry.setTag("userId", userId);
  }, [userId]);
  return null;
}
